export default __webpack_public_path__ + "static/media/bg-image@2x.29637313.png";